import * as React from "react"
import { Typography } from '@mui/material'


export default function dashboardColumn() {
    return {
		name: 'dashboard',
		label: 'Dashboard',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ fontSize: '0.875rem' }}>
				{value || '-'}
			</Typography>
		}
	}
}